import React, { useState } from "react";
import {
  FaHeart,
  FaBookmark,
  FaClock,
  FaChevronDown,
  FaChevronUp,
  FaCheckCircle,
  FaWhatsapp,
  FaArrowRight,
  FaEnvelope,
  FaTimes,
  FaFirstAid,
  FaHandsHelping,
} from "react-icons/fa";

export const BlogSinglePage3 = () => {
  const [openAid, setOpenAid] = useState(1);
  const [selectedBlog, setSelectedBlog] = useState(null);

  const tips = [
    {
      id: 1,
      title: "Cómo controlar una hemorragia",
      content:
        "Aplica presión directa con una gasa o paño limpio. Si se humedece, añade más capas sin retirar la anterior. Mantén presión constante y busca ayuda médica.",
    },
    {
      id: 2,
      title: "Cómo realizar RCP",
      content:
        "Ubica las manos en el centro del pecho y realiza compresiones firmes y rápidas entre 100 y 120 por minuto hasta que llegue ayuda.",
    },
    {
      id: 3,
      title: "Cómo tratar una quemadura leve",
      content:
        "Enfría la zona con agua fresca durante 10 minutos. No uses hielo. Cubre con una venda limpia y observa evolución.",
    },
  ];

  const related = [
    {
      title: "Qué llevar en un botiquín básico",
      img: "https://images.pexels.com/photos/40568/medical-appointment-doctor-healthcare-40568.jpeg?auto=compress&cs=tinysrgb&w=600",
      desc:
        "Elementos esenciales para emergencias domésticas, viajes y trabajo.",
    },
    {
      title: "Cómo actuar ante desmayos",
      img: "https://images.pexels.com/photos/6129507/pexels-photo-6129507.jpeg?auto=compress&cs=tinysrgb&w=600",
      desc:
        "Aprende medidas seguras y pasos inmediatos ante pérdida de conciencia.",
    },
    {
      title: "Prevención en el hogar",
      img: "https://images.pexels.com/photos/6646918/pexels-photo-6646918.jpeg?auto=compress&cs=tinysrgb&w=600",
      desc:
        "Reduce riesgos comunes y prepara a tu familia ante incidentes.",
    },
  ];

  return (
    <div className="bg-[#f5f6fa] min-h-screen">
      {/* HERO */}
      <section className="relative h-[650px] overflow-hidden">
        <img
          src="https://images.pexels.com/photos/3760275/pexels-photo-3760275.jpeg?auto=compress&cs=tinysrgb&w=1600"
          alt="Cevacruz"
          className="w-full h-full object-cover"
        />

        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/20"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>

        <div className="absolute top-0 left-0 w-full h-2 flex">
          <div className="w-1/3 bg-red-600"></div>
          <div className="w-1/3 bg-yellow-400"></div>
          <div className="w-1/3 bg-blue-800"></div>
        </div>

        <div className="absolute inset-0 max-w-7xl mx-auto px-6 flex items-center">
          <div className="max-w-3xl text-white">
            <span className="bg-red-600 px-4 py-2 rounded-full text-sm font-bold">
              CEVACRUZ
            </span>

            <h1 className="text-6xl md:text-4xl font-extrabold leading-tight mt-6">
              ¿Qué hacer en caso de una emergencia?
            </h1>

            <p className="text-xl text-gray-200 mt-6">
              Aprende acciones rápidas y seguras para actuar correctamente.
            </p>

            <div className="flex flex-wrap gap-4 mt-8">
              <InfoBtn icon={<FaClock />} text="6 min lectura" />
              <InfoBtn icon={<FaHeart />} text="Importante" />
              <InfoBtn icon={<FaBookmark />} text="Guardar" />
            </div>
          </div>
        </div>
      </section>

      {/* CONTENIDO */}
      <section className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-3 gap-8">
        {/* IZQUIERDA */}
        <div className="col-span-2 space-y-8">
          <div className="bg-white rounded-3xl shadow-lg p-8">
            <h2 className="text-4xl font-bold text-blue-950 mb-5">
              La preparación salva vidas
            </h2>

            <p className="text-gray-600 text-lg leading-relaxed">
              Mantener la calma y actuar con criterio puede marcar la
              diferencia en una situación crítica.
            </p>

            <img
              src="https://images.pexels.com/photos/6520061/pexels-photo-6520061.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Primeros auxilios"
              className="w-full h-[420px] object-cover rounded-2xl mt-8"
            />
          </div>

          <div className="bg-white rounded-3xl shadow-lg p-8">
            <div className="flex items-center gap-4 mb-8">
              <FaFirstAid className="text-red-600 text-3xl" />
              <h3 className="text-3xl font-bold text-blue-950">
                Guía Interactiva
              </h3>
            </div>

            <div className="space-y-4">
              {tips.map((item) => (
                <div
                  key={item.id}
                  className="border border-gray-200 rounded-2xl overflow-hidden"
                >
                  <button
                    onClick={() =>
                      setOpenAid(openAid === item.id ? null : item.id)
                    }
                    className="w-full flex justify-between items-center p-5"
                  >
                    <div className="flex items-center gap-4">
                      <span className="w-9 h-9 rounded-full bg-red-600 text-white flex items-center justify-center font-bold">
                        {item.id}
                      </span>

                      <span className="font-bold text-blue-950">
                        {item.title}
                      </span>
                    </div>

                    {openAid === item.id ? (
                      <FaChevronUp />
                    ) : (
                      <FaChevronDown />
                    )}
                  </button>

                  {openAid === item.id && (
                    <div className="px-6 pb-6 text-gray-600">
                      {item.content}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* DERECHA */}
        <div className="space-y-8">
          <div className="bg-white rounded-3xl shadow-lg p-8">
            <h3 className="text-3xl font-bold text-blue-950 mb-6">
              Aprende Hoy
            </h3>

            <div className="space-y-4">
              {[
                "Control de hemorragias",
                "RCP básica",
                "Atención de quemaduras",
                "Prevención y seguridad",
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-3">
                  <FaCheckCircle className="text-red-600" />
                  {item}
                </div>
              ))}
            </div>
          </div>

          {/* BLOGS RELACIONADOS */}
          <div className="bg-white rounded-3xl shadow-lg p-8">
            <h3 className="text-3xl font-bold text-blue-950 mb-6">
              Blogs Relacionados
            </h3>

            <div className="space-y-5">
              {related.map((item, i) => (
                <div
                  key={i}
                  onClick={() => setSelectedBlog(item)}
                  className="flex gap-4 group cursor-pointer hover:bg-gray-50 p-3 rounded-xl transition"
                >
                  <img
                    src={item.img}
                    alt=""
                    className="w-24 h-24 rounded-xl object-cover"
                  />

                  <div>
                    <h4 className="font-bold text-blue-950 group-hover:text-red-600 transition">
                      {item.title}
                    </h4>

                    <span className="flex items-center gap-2 text-red-600 mt-2 text-sm font-semibold">
                      Leer más <FaArrowRight />
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* NEWSLETTER */}
          <div className="bg-red-600 rounded-3xl shadow-xl p-8 text-white">
            <FaEnvelope className="text-4xl mb-5" />

            <h3 className="text-3xl font-bold">Mantente informado</h3>

            <p className="mt-3 text-red-100">
              Consejos útiles, prevención y comunidad Cevacruz.
            </p>

            <input
              type="email"
              placeholder="Tu correo electrónico"
              className="w-full mt-6 px-4 py-4 rounded-xl text-gray-800"
            />

            <a
              href="https://www.facebook.com/cevaturpiura"
              target="_blank"
              rel="noreferrer"
            >
              <button className="w-full mt-4 bg-blue-950 hover:bg-blue-900 py-4 rounded-xl font-bold transition">
                Suscribirme
              </button>
            </a>
          </div>
        </div>

        {/* CTA */}
        <div className="col-span-3">
          <div className="rounded-3xl bg-blue-950 text-white p-10 shadow-xl relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-600 via-yellow-400 to-blue-700"></div>

            <h3 className="text-4xl font-bold">
              Aprende Primeros Auxilios con Cevatur
            </h3>

            <p className="text-gray-300 mt-4 max-w-3xl text-lg">
              Formación práctica para responder con seguridad ante emergencias.
            </p>

            <div className="flex flex-wrap gap-4 mt-8">
              <a
                href="https://wa.me/51967575397"
                target="_blank"
                rel="noreferrer"
              >
                <button className="bg-green-500 hover:bg-green-600 px-8 py-4 rounded-xl font-bold flex items-center gap-3">
                  <FaWhatsapp />
                  Solicitar Información
                </button>
              </a>

            </div>
          </div>
        </div>
      </section>

      {/* MODAL */}
      {selectedBlog && (
        <div className="fixed inset-0 bg-black/70 z-50 flex justify-center items-center px-4">
          <div className="bg-white max-w-2xl w-full rounded-3xl overflow-hidden shadow-2xl relative">
            <button
              onClick={() => setSelectedBlog(null)}
              className="absolute top-4 right-4 bg-red-600 text-white w-10 h-10 rounded-full flex items-center justify-center"
            >
              <FaTimes />
            </button>

            <img
              src={selectedBlog.img}
              alt=""
              className="w-full h-64 object-cover"
            />

            <div className="p-7">
              <h2 className="text-2xl font-bold text-blue-950">
                {selectedBlog.title}
              </h2>

              <p className="text-gray-600 mt-4 leading-7">
                {selectedBlog.desc}
              </p>

              <div className="mt-6 flex items-center gap-3 text-red-600 font-semibold">
                <FaHandsHelping />
                Preparación y ayuda responsable
              </div>

              <button
                onClick={() => setSelectedBlog(null)}
                className="mt-7 bg-blue-950 text-white px-6 py-3 rounded-xl font-bold"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const InfoBtn = ({ icon, text }) => (
  <button className="border border-white/40 px-5 py-3 rounded-xl flex items-center gap-3 hover:bg-white hover:text-black transition">
    {icon}
    {text}
  </button>
);

export default BlogSinglePage3;